<script setup>
import { computed } from 'vue'
import { CircleStackIcon } from '@heroicons/vue/24/outline'
import { sourceSelectionState } from '../platform/context.js'
import { useI18n } from '../i18n.js'

const props = defineProps({
  context: { type: Object, default: null },
  disabled: { type: Boolean, default: false },
  compact: { type: Boolean, default: false },
})
const emit = defineEmits(['select'])
const { t } = useI18n()
const state = computed(() => sourceSelectionState(props.context))

function select(event) {
  const sourceId = Number(event.target.value)
  if (sourceId) emit('select', sourceId)
}
</script>

<template>
  <label v-if="state.station" class="platform-context-selector source-context-selector" :class="{ compact }">
    <CircleStackIcon aria-hidden="true" />
    <span v-if="!compact">{{ t('naftaPosWorkplace') }}</span>
    <select :value="context?.activeNaftaPosInstanceId ?? ''" :disabled="disabled || !state.sources.length"
      :aria-label="t('naftaPosWorkplace')" @change="select">
      <option value="" disabled>{{ state.sources.length ? t('chooseNaftaPosWorkplace') : t('noNaftaPosWorkplaces') }}</option>
      <option v-for="source in state.sources" :key="source.id" :value="source.id" :disabled="!source.enabled">
        {{ source.displayName }}
      </option>
    </select>
  </label>
</template>
